import { Mail, Calendar, FileText, BarChart3 } from "lucide-react";

const wasted = [
  { icon: Mail, label: "Inbox triage & repetitive replies" },
  { icon: Calendar, label: "Scheduling, reminders, follow-ups" },
  { icon: FileText, label: "Drafting docs, briefs & content" },
  { icon: BarChart3, label: "Manual reporting & data wrangling" },
];

export const Problem = () => {
  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="relative py-24 sm:py-32 bg-white border-t border-[#E5E5E5]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0052FF] mb-5">
              The Problem
            </div>
            <h2
              data-testid="problem-headline"
              className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1] text-[#0A0A0A]"
            >
              Most businesses waste time on repetitive work.
            </h2>
          </div>

          <div className="lg:col-span-7 space-y-6">
            <p
              data-testid="problem-paragraph-1"
              className="text-lg leading-relaxed text-[#525252]"
            >
              Business owners and operators spend too much time on scheduling,
              emails, meetings, content creation, reporting, and administrative
              work.
            </p>
            <p
              data-testid="problem-paragraph-2"
              className="text-lg leading-relaxed text-[#525252]"
            >
              AI can automate much of this work — but most people don&apos;t know
              where to start.
            </p>

            <ul
              data-testid="problem-list"
              className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3"
            >
              {wasted.map(({ icon: Icon, label }) => (
                <li
                  key={label}
                  className="flex items-center gap-3 rounded-xl border border-[#E5E5E5] bg-[#FAFAFA] px-4 py-3"
                >
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-white border border-[#E5E5E5] text-[#0052FF]">
                    <Icon size={18} />
                  </span>
                  <span className="text-sm font-semibold text-[#0A0A0A]">
                    {label}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Problem;
